import { useTranslate, IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  Form,
  Input,
  useForm,
} from "@pankod/refine-antd";

import "react-mde/lib/styles/css/react-mde-all.css";

import { IMessage } from "interfaces";

export const MessageEdit: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { formProps, saveButtonProps } = useForm<IMessage>();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label={t("message.fields.message")} name="message" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label={t("message.fields.link")} name="link">
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
